const COLORS = ['#8B1A1A', '#B4491F', '#A0671A', '#4D7A2B', '#1F6F6B', '#2B5C8A', '#5B3F8C', '#8A2F6B'];
function imageAt(url) {
  return new Promise(resolve => {
    if (!url) {
      resolve(null);
      return;
    }
    const img = new Image();
    img.crossOrigin = 'anonymous';
    const timer = setTimeout(() => resolve(null), 6000);
    img.onload = () => {
      clearTimeout(timer);
      resolve(img);
    };
    img.onerror = () => {
      clearTimeout(timer);
      resolve(null);
    };
    img.src = url;
  });
}
function initials(name) {
  return String(name || '?').replace(/[^A-Za-z0-9]/g, '').slice(0, 1).toUpperCase() || '?';
}
function wrap(ctx, text, width) {
  const lines = [];
  for (const paragraph of String(text || '').split('\n')) {
    let line = '';
    for (const word of paragraph.split(/\s+/)) {
      if (ctx.measureText(line + ' ' + word).width > width && line) {
        lines.push(line);
        line = word;
      } else line += (line ? ' ' : '') + word;
    }
    lines.push(line);
  }
  return lines;
}
function photo(ctx, img, x, y, w, h) {
  const scale = Math.max(w / img.width, h / img.height),
    sw = w / scale,
    sh = h / scale;
  ctx.drawImage(img, (img.width - sw) / 2, (img.height - sh) / 2, sw, sh, x, y, w, h);
}
export async function createShareCard(restaurant, post) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Image export is unavailable.');
  const [logo, venue] = await Promise.all([imageAt('/assets/VolcyyWhiteLogo.PNG'), imageAt(restaurant.imageUrl)]);
  ctx.fillStyle = '#8B1A1A';
  ctx.fillRect(0, 0, 1080, 1920);
  if (logo) {
    const ratio = Math.min(300 / logo.width, 110 / logo.height);
    ctx.drawImage(logo, (1080 - logo.width * ratio) / 2, 140, logo.width * ratio, logo.height * ratio);
  } else {
    ctx.fillStyle = '#fff';
    ctx.font = 'bold 72px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('Volcyy', 540, 220);
  }
  const x = 90,
    w = 900;
  ctx.fillStyle = '#fff';
  ctx.beginPath();
  ctx.roundRect(x, 390, w, 1120, 32);
  ctx.fill();
  ctx.save();
  ctx.beginPath();
  ctx.roundRect(x, 390, w, 330, [32, 32, 0, 0]);
  ctx.clip();
  if (venue) photo(ctx, venue, x, 390, w, 330);else {
    ctx.fillStyle = '#6F1515';
    ctx.fillRect(x, 390, w, 330);
    ctx.fillStyle = '#fff';
    ctx.textAlign = 'center';
    ctx.font = 'bold 140px Arial';
    ctx.fillText(initials(restaurant.name), 540, 610);
  }
  ctx.restore();
  ctx.textAlign = 'left';
  ctx.fillStyle = '#1d1d1f';
  ctx.font = 'bold 46px Arial';
  const names = wrap(ctx, restaurant.name, 780);
  names.slice(0, 2).forEach((line, i) => ctx.fillText(line, 150, 790 + i * 52));
  ctx.font = '32px Arial';
  ctx.fillStyle = '#8B1A1A';
  ctx.fillText(post.rating ? '★'.repeat(post.rating) + '☆'.repeat(5 - post.rating) : restaurant.ratingAvg ? `★ ${Number(restaurant.ratingAvg).toFixed(1)}` : 'Volcyy reviews', 150, 915);
  const name = post.authorHandle || 'night_owl';
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = hash * 31 + name.charCodeAt(i) >>> 0;
  ctx.fillStyle = COLORS[hash % COLORS.length];
  ctx.beginPath();
  ctx.arc(183, 1000, 33, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#fff';
  ctx.textAlign = 'center';
  ctx.font = 'bold 32px Arial';
  ctx.fillText(initials(name), 183, 1012);
  ctx.textAlign = 'left';
  ctx.fillStyle = '#1d1d1f';
  ctx.font = 'bold 32px Arial';
  ctx.fillText('@' + name.replace(/^@/, ''), 235, 1012, 685);
  let font = 38,
    lines;
  do {
    ctx.font = `${font}px Arial`;
    lines = wrap(ctx, post.text, 780);
    if (lines.length * (font * 1.35) <= 340) break;
    font -= 2;
  } while (font > 22);
  ctx.fillStyle = '#333';
  lines.slice(0, Math.floor(340 / (font * 1.35))).forEach((line, i) => ctx.fillText(line, 150, 1090 + i * font * 1.35, 780));
  if (restaurant.imageAttribution?.length) {
    ctx.fillStyle = '#6e6e73'; ctx.font = '20px Arial';
    ctx.fillText('Photo: ' + restaurant.imageAttribution.map(author => author.displayName).join(', ') + ' - Google', 150, 1430, 780);
  }
  ctx.fillStyle = '#6e6e73';
  ctx.font = '24px Arial';
  ctx.fillText('volcyy.com', 150, 1460);
  return new Promise((resolve, reject) => canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('Could not create image.')), 'image/png'));
}
export async function saveShareCard(restaurant, post) {
  const blob = await createShareCard(restaurant, post),
    name = `volcyy-${String(restaurant.name || 'review').replace(/[^a-z0-9]+/gi, '-')}.png`,
    file = new File([blob], name, {
      type: 'image/png'
    });
  if (navigator.canShare?.({
    files: [file]
  })) {
    try {
      await navigator.share({
        files: [file],
        title: restaurant.name
      });
      return;
    } catch (error) {
      if (error.name === 'AbortError') return;
    }
  }
  const url = URL.createObjectURL(blob),
    a = document.createElement('a');
  a.href = url;
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
